
import {Component, Vue, Prop} from 'vue-property-decorator';
import {AIMonitorApi} from '@/api';
import aiConfigList from '@/js/aiConfig/aiconfig-list.helper';
import Empty from '@/components/Empty/index.vue';
import moment from 'moment';
@Component({
    components: {Empty}
})
export default class StudentUsage extends Vue {
    @Prop({default: () => []}) schoolParams!: Array<string>;
    searchQuery = {AIability: 'fr'};
    usageList = aiConfigList.aiConfigItem;
    dataList = [];
    tempList = [];
    getData(status?: string) {
        if (status === 'fail') return;
        AIMonitorApi.getStudentUsage({
            context: this,
            classId: this.schoolParams[1],
            data: {type: this.searchQuery.AIability},
            success: (data: any) => {
                if (data.code === 0) {
                    if (data.data.usage && data.data.usage.length) {
                        this.dataList = data.data.usage.map((item: {_id: any; nickname: any; amount: number}) => {
                            return {
                                id: item._id,
                                nickname: item.nickname,
                                progress: Math.floor((item.amount / data.data.rule.max) * 10000) / 100,
                                amount: item.amount,
                                max: data.data.rule.max,
                                remain: data.data.rule.max - item.amount,
                                status: data.data.rule.max - item.amount <= data.data.rule.threshold ? 'warn' : 'nomal'
                            };
                        });
                        this.tempList = this.dataList.length > 10 ? this.dataList.slice(0, 10) : this.dataList;
                    }
                }
            }
        });
    }
    onChangeAbility(val: any) {
        this.getData();
    }
    isExtend = false;
    showMore() {
        this.isExtend = !this.isExtend;
        this.tempList = this.isExtend ? this.dataList : this.dataList.slice(0, 10);
    }

    formatMsTime(time: string) {
        const days = moment.duration(time).days() ? moment.duration(time).days() : 0;
        const hour = moment.duration(time).hours() ? days * 24 + moment.duration(time).hours() + '时' : '';
        const min = moment.duration(time).minutes() ? moment.duration(time).minutes() + '分' : '';
        const second = moment.duration(time).seconds() ? moment.duration(time).seconds() + '秒' : '';
        return hour + min + second ? hour + min + second : 0;
    }
}
